import { apiBaseURL, assetType, toastifyType, toastTypes, ycrAssetType } from "../../../constant";
import { setLoading } from "../loadingAction";
import apiConfig from '../../../config/apiConfig';
import { addTost } from "../toastAction";
import { metaDataAction } from "../metaDataAction";


export const fetchPrices = (payload) => async (dispatch) => {
  // debugger
  try {
    dispatch(setLoading(true));
    const response = await apiConfig.post(apiBaseURL.INTEREST_RATES_DATA_TYPES_ASSET, payload);
    dispatch({ type: ycrAssetType.FETCH_INTEREST_RATES_DATA_TYPES_ASSET, payload: response.data.data });
    dispatch(metaDataAction({ pageSize: payload?.perPage, totalPages: response.data.data.totalPage, totalItems: response.data.data.totalRecords }))
    dispatch(setLoading(false));
    return response
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
  }
};


export const priceSubData = (payload) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await apiConfig.post(apiBaseURL.ASSET_VALUE, payload);
    dispatch({ type: ycrAssetType.FETCH_INTEREST_RATES_DATA_TYPES_DETAILS_ASSET, payload: response.data.data });
    dispatch(metaDataAction({ pageSize: payload?.perPage, totalPages: response.data.data.totalPage, totalItems: response.data.data.totalRecords }))
    dispatch(setLoading(false));
    return response
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
  }
};